import React from 'react';
import { Icon } from 'antd';

const Error = () => (
  <div>
    <Icon type="frown-o" />
    <h1>404 Not Found</h1>
  </div>
);

export default Error;



// WEBPACK FOOTER //
// ./src/features/error/index.js